/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, heights } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- USER DATA COLLECTION SUCCESS PHASE STYLES --------------- ++++++++++ */
export default {
    udcsfetching: {
        '& .title': {
            marginTop: pxToEm(70),
            marginBottom: pxToEm(10),
            '& h2': {
                opacity: 0,
                animationName: 'fadeIn',
                animationDuration: '2s',
                animationDelay: '1.5s',
                animationFillMode: 'forwards',
            }
        },
        '& .bodycopy': {
            '& p': {
                opacity: 0,
                animationName: 'fadeIn',
                animationDuration: '2s',
                animationDelay: '1.7s',
                animationFillMode: 'forwards',
            }
        },
        '& .loading': {
            paddingTop: pxToEm(25),
            textAlign: 'center',
            width: '100%',
            '& .logo': {
                position: 'absolute',
                top: heights.header,
                left: pxToEm(15),
                fontSize: '150%',
                margin: '-52px 0 0 -10px'
            },
            '& .loader': {
                marginBottom: pxToEm(10)
            },
            '& .bodycopy': {
                textAlign: 'center'
            }
        }
    }
};
